'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var createReactClass = require('create-react-class');
var MapCanvas = require('./MapCanvas');
var LocalizeMixin = require('../../localization/CommonLocalizationMixin');

var Filters = function (_React$Component) {
    _inherits(Filters, _React$Component);

    function Filters() {
        var _temp, _this, _ret;

        _classCallCheck(this, Filters);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
            checked: []
        }, _this.checkboxHandler = function (id) {
            //get array of checked boxes
            var data = _this.state.checked;

            if (data.indexOf(id) > -1) {
                data.splice(data.indexOf(id), 1);
            } else {
                data.push(id);
            }

            _this.setState({
                checked: data
            });

            if (_this.props.checkboxHandler) {
                _this.props.checkboxHandler(data);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    Filters.prototype.render = function render() {
        return React.createElement(
            'div',
            { className: 'filters-container', style: this.props.style },
            React.createElement(
                'ul',
                null,
                React.createElement(
                    'li',
                    null,
                    React.createElement(
                        'input',
                        { id: 'breakfast-checkbox', type: 'checkbox', onChange: this.checkboxHandler.bind(this, 'hasBreakfast') },
                        React.createElement(
                            'span',
                            { id: 'breakfast-span' },
                            this.props.getLocalizedText('search_container_breakfast')
                        )
                    )
                ),
                React.createElement(
                    'li',
                    null,
                    React.createElement(
                        'input',
                        { id: 'cso-checkbox', type: 'checkbox', onChange: this.checkboxHandler.bind(this, 'hasCSO') },
                        React.createElement(
                            'span',
                            { id: 'cso-span' },
                            this.props.getLocalizedText('search_container_cso')
                        )
                    )
                ),
                React.createElement(
                    'li',
                    null,
                    React.createElement(
                        'input',
                        { id: 'has-freestyle-checkbox', type: 'checkbox', onChange: this.checkboxHandler.bind(this, 'hasCokeFreestyle') },
                        React.createElement(
                            'span',
                            { id: 'has-freestyle-span' },
                            this.props.getLocalizedText('search_container_free_style')
                        )
                    )
                ),
                React.createElement(
                    'li',
                    null,
                    React.createElement(
                        'input',
                        { id: 'has-coupon-checkbox', type: 'checkbox', onChange: this.checkboxHandler.bind(this, 'hasDigitalCoupon') },
                        React.createElement(
                            'span',
                            { id: 'has-coupon-span' },
                            this.props.getLocalizedText('search_container_digital_coupon')
                        )
                    )
                ),
                React.createElement(
                    'li',
                    null,
                    React.createElement(
                        'input',
                        { id: 'has-hola-checkbox', type: 'checkbox', onChange: this.checkboxHandler.bind(this, 'hasHola') },
                        React.createElement(
                            'span',
                            { id: 'has-hola-span' },
                            this.props.getLocalizedText('search_container_hola')
                        )
                    )
                ),
                React.createElement(
                    'li',
                    null,
                    React.createElement(
                        'input',
                        { id: 'has-loyalty-checkbox', type: 'checkbox', onChange: this.checkboxHandler.bind(this, 'hasLoyalty') },
                        React.createElement(
                            'span',
                            { id: 'has-loyalty-span' },
                            this.props.getLocalizedText('search_container_loyalty')
                        )
                    )
                ),
                React.createElement(
                    'li',
                    null,
                    React.createElement(
                        'input',
                        { id: 'has-mcx-checkbox', type: 'checkbox', onChange: this.checkboxHandler.bind(this, 'hasMCX') },
                        React.createElement(
                            'span',
                            { id: 'has-mcx-span' },
                            this.props.getLocalizedText('search_container_mcx')
                        )
                    )
                ),
                React.createElement(
                    'li',
                    null,
                    React.createElement(
                        'input',
                        { id: 'has-mobile-order-checkbox', type: 'checkbox', onChange: this.checkboxHandler.bind(this, 'hasMobileOrder') },
                        React.createElement(
                            'span',
                            { id: 'has-mobile-order-span' },
                            this.props.getLocalizedText('search_container_mobile_ordering')
                        )
                    )
                ),
                React.createElement(
                    'li',
                    null,
                    React.createElement(
                        'input',
                        { id: 'has-mobile-pay-checkbox', type: 'checkbox', onChange: this.checkboxHandler.bind(this, 'hasMobilePay') },
                        React.createElement(
                            'span',
                            { id: 'has-mobile-pay-span' },
                            this.props.getLocalizedText('search_container_mobile_pay')
                        )
                    )
                ),
                React.createElement(
                    'li',
                    null,
                    React.createElement(
                        'input',
                        { id: 'has-wifi-checkbox', type: 'checkbox', onChange: this.checkboxHandler.bind(this, 'hasWifi') },
                        React.createElement(
                            'span',
                            { id: 'has-wifi-span' },
                            this.props.getLocalizedText('search_container_wifi')
                        )
                    )
                ),
                React.createElement(
                    'li',
                    null,
                    React.createElement(
                        'input',
                        { id: 'is-24h-checkbox', type: 'checkbox', onChange: this.checkboxHandler.bind(this, 'isOpen24Hours') },
                        React.createElement(
                            'span',
                            { id: 'is-24h-span' },
                            this.props.getLocalizedText('search_container_24_hours')
                        )
                    )
                ),
                React.createElement(
                    'li',
                    null,
                    React.createElement(
                        'input',
                        { id: 'is-open-late-checkbox', type: 'checkbox', onChange: this.checkboxHandler.bind(this, 'isOpenLate') },
                        React.createElement(
                            'span',
                            { id: 'is-open-late-span' },
                            this.props.getLocalizedText('search_container_open_late')
                        )
                    )
                )
            )
        );
    };

    return Filters;
}(React.Component);

module.exports = createReactClass({
    displayName: 'exports',

    mixins: [LocalizeMixin],
    getInitialState: function getInitialState() {
        return {
            filterShowing: false
        };
    },
    render: function render() {
        var filterStyle = this.state.filterShowing ? {} : { display: 'none' };
        return React.createElement(
            'div',
            { className: 'map-container' },
            React.createElement(
                'div',
                { className: 'search-controls' },
                React.createElement(
                    'form',
                    { onSubmit: this.handleSearchButtonClick },
                    React.createElement('input', { id: 'find-search-input-text', type: 'text', className: 'search-bar',
                        placeholder: 'Enter City, State, or Zipcode', ref: 'find_search_input_text' }),
                    React.createElement('input', { id: 'find-search-input-submit', type: 'button', className: 'btn btn-default', value: 'Search',
                        onClick: this.handleSearchButtonClick }),
                    React.createElement(
                        'div',
                        { className: 'glyph-button', onClick: this.handleMyLocationClick },
                        React.createElement('span', { id: 'find-search-my-location', className: 'glyphicon glyphicon-screenshot' })
                    ),
                    React.createElement(
                        'div',
                        { onClick: this.handleFilterClick, className: 'glyph-button' },
                        React.createElement('span', { id: 'find-search-filter', className: 'glyphicon glyphicon-filter' })
                    ),
                    React.createElement(Filters, {
                        getLocalizedText: this.getLocalizedText,
                        checkboxHandler: this.checkboxHandler,
                        style: filterStyle })
                )
            ),
            React.createElement(MapCanvas, { mapLoaded: this.mapLoaded, locations: this.props.locations, ref: 'map_canvas' })
        );
    },
    checkboxHandler: function checkboxHandler(data) {
        console.log('filter handler in main');
        if (this.props.filterCheckboxHandler) {
            this.props.filterCheckboxHandler(data);
        }
    },
    handleSearchButtonClick: function handleSearchButtonClick() {
        var searchValue = this.refs.find_search_input_text.getDOMNode().value;
        if (this.props.handleSearchButtonClick) {
            this.props.handleSearchButtonClick(searchValue);
        }

        return false;
    },
    handleFilterClick: function handleFilterClick() {
        this.setState({
            filterShowing: !this.state.filterShowing
        });
    },
    handleMyLocationClick: function handleMyLocationClick() {
        if (this.props.handleMyLocationClick) {
            this.props.handleMyLocationClick();
        }
    },
    mapLoaded: function mapLoaded() {
        if (this.props.mapLoaded) {
            this.props.mapLoaded();
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/mapComponents/SearchContainer.js
// module id = 821
// module chunks = 0